import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconProgressArc: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconProgressArc"><Path d="M21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><Path d="M12 5.25C13.2089 5.25 14.3955 5.57464 15.436 6.18999C16.4765 6.80535 17.3327 7.68884 17.9151 8.74816C18.4974 9.80749 18.7846 11.0038 18.7467 12.212C18.7087 13.4203 18.3469 14.5962 17.6992 15.6168L12 12V5.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconProgressArc;
